import { useMutation, useQueryClient } from "@tanstack/react-query";
import axiosInstance from "../../../../config/apiConfig";

const postCaseStudy = async (caseStudyData) => {
  try {
    const { data } = await axiosInstance.post("/CaseStudies", caseStudyData);
    return data;
  } catch (error) {
    console.error("Error posting case study:", error);
    throw error;
  }
};

const usePostCaseStudy = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: postCaseStudy,
    onSuccess: () => {
      queryClient.invalidateQueries(["caseStudies"]);
    },
    onError: (err) => {
      console.error("Post case study mutation failed:", err);
    },
  });
};

export default usePostCaseStudy;

